// extracted by mini-css-extract-plugin
export var body = "_m2-0";
export var sectionHeader = "_m2-4";
export var shortcutColumns = "_m2-2";
export var shortcutList = "_m2-1";
export var shortcutSection = "_m2-3";